import { useApi } from '@/api';
import {
  ActivityCard,
  Blockie,
  EntityName,
  KpiCard,
  Page,
  PageSkeleton
} from '@/components';
import { tokensMapping } from '@/utils/tokens';
import {
  ArrowRightIcon,
  Box,
  Card,
  CryptoIcon,
  Flex,
  Heading,
  WalletAddress,
  addressShortener
} from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import HistoricTabs from './HistoricTabs';
export default function StakingEngineVaultPage() {
  const { urn } = useParams();
  const ilk = 'LSEV2-SKY-A';

  const [data, error] = useApi({
    url: `/groups/staked/ilks/${ilk}/cdps/${urn}/`,
    queryParams: {
      days_ago: 1
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const urnTitle = data.cdp ? data.cdp : addressShortener({ address: urn });
    return (
      <Page
        title={
          <EntityName
            symbol1={
              <CryptoIcon
                name={data.collateral_symbol}
                address={tokensMapping(data.collateral_symbol).address}
                size="3"
              />
            }
            symbol2={<Blockie address={urn} imgSize="3" />}>
            <Heading size="1">
              {data.ilk} <ArrowRightIcon size="2" /> {urnTitle}
            </Heading>
          </EntityName>
        }>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Collateral Ratio"
            data={data}
            field="collateralization_ratio"
            options={{ percentage: true }}
          />
          <Card
            gap="xs"
            display="flex"
            flexDirection="column"
            justifyContent="center">
            {/* <Flex justifyContent="space-between">
                <div>Protection score</div>
                <div>
                  <Badge text="#TODO" />
                </div>
              </Flex> */}
            <Flex justifyContent="space-between" gap="xs">
              <Box>URN</Box>

              <WalletAddress
                options={{
                  inline: true,
                  showCopyBtn: true,
                  showBlockie: false
                }}
                address={data.urn}
              />
            </Flex>
            {data.owner ? (
              <Flex justifyContent="space-between" gap="s">
                <Box>Owner</Box>

                <WalletAddress
                  options={{
                    inline: true,
                    showBlockie: false,
                    showDebankLink: true,
                    showEthScanLink: true,
                    showZapperLink: true
                  }}
                  address={data.owner}
                />
              </Flex>
            ) : null}
            {data.proxy ? (
              <Flex justifyContent="space-between" gap="s">
                <Box>DS Proxy</Box>

                <WalletAddress
                  options={{
                    inline: true,
                    showBlockie: false,
                    showDebankLink: true,
                    showEthScanLink: true,
                    showZapperLink: true
                  }}
                  address={data.proxy}
                />
              </Flex>
            ) : null}
          </Card>
        </Flex>

        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Debt"
            data={data}
            field="debt"
            variant="usds"
            options={{
              currency: 'USDS',
              valueOptions: { currencyValueOptions: { iconSize: '3' } }
            }}
          />
          <KpiCard
            title="Collateral"
            data={data}
            field="ink"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  iconSize: '3',
                  currency: tokensMapping(data.collateral_symbol)
                }
              }
            }}
          />
          <KpiCard
            title="Liquidation Price"
            data={data}
            field="liquidation_price"
            options={{
              currency: 'USD',
              valueOptions: { currencyValueOptions: { iconSize: '3' } }
            }}
          />
        </Flex>
        <HistoricTabs collateralSymbol={data.collateral_symbol} />
        <ActivityCard
          url={`/groups/staked/ilks/${ilk}/cdps/${urn}/activity/`}
          linkTo="activity"
        />
      </Page>
    );
  }
  return <PageSkeleton />;
}
